module.exports = __webpack_public_path__ + "img/1282_1.jpg";